import * as ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators'

export default {
  ui: {},

  init() {
    // JavaScript to be fired on all pages
    this.bindUI();
    this.bindEvents();
  },

  bindUI() {
		this.ui.win     = window;
    this.ui.aside   = document.querySelector('.js-aside');
    this.ui.navItem = this.ui.aside.querySelectorAll('a');
    this.ui.blocks 	= document.querySelectorAll('.block');
  },
  
  bindEvents() {

    // When window is loaded, initAside.
		this.ui.win.addEventListener('load', this.initAside.bind(this));

		// When window is resized, initAside.
		this.ui.win.addEventListener('resize', this.initAside.bind(this));
 
	},

	initAside() {
    
    let controller = new ScrollMagic.Controller();
    let self = this;
    let scene = [];
    
		for(var i = 0; i < this.ui.blocks.length; i++) {
		
			let element = this.ui.blocks[i];
      let block = element.getAttribute('data-block');
      
			scene[i] = new ScrollMagic.Scene({
					triggerElement: element,
					triggerHook: 0,
					duration: element.offsetHeight + 'px',
					offset: '-300px',
					reverse: true,
				})
				.on('enter', function () {

          if (element.classList.contains('block-color')) {
            self.ui.aside.classList.add('reverse');
          } else {
            self.ui.aside.classList.remove('reverse');
          }

					// Remove class from other items.
					for (let j = 0, k = self.ui.navItem.length; j < k; j++) {
						self.ui.navItem[j].classList.remove('is-active');
					}

          // On met à jour le sous-menu
          if (block == 'contact') {
            self.ui.navItem[self.ui.navItem.length - 1].classList.add('is-active');
          } else {
            self.ui.navItem[block].classList.add('is-active');
          }

				})
				// .addIndicators({name: 'block-'+i})
				.addTo(controller);

		}

  },

  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/util/aside.js